// Modul zur Erfassung von einfachen Finanzierungs-Positionen
"use strict";

import foerdermoduleRegistry from "dias/foerderantrag/foerdermodule";
import controller from "./controller";
import template from "./template.jade";
import FoerderantragModels from "dias/foerderantrag/models";
import VertragModels from "dias/vertrag/models";

import builder from "dias/standard_foerdermodule/utils/builder";


const standard_finanzierung = angular.module("dias.standard_finanzierung.standard_finanzierung", [
  foerdermoduleRegistry.name,
  FoerderantragModels.name,
  VertragModels.name,
]);

standard_finanzierung.config(/*@ngInject*/ FoerdermoduleRegistryProvider => {
  FoerdermoduleRegistryProvider.register("standard_finanzierung", "modul-standard-finanzierung");
})

  .directive("modulStandardFinanzierung", builder.directive(template, controller));

export default standard_finanzierung;
